import { FileText, ClipboardCheck, GraduationCap, MessageCircle } from "lucide-react";
import { PERSONA_COLORS } from "./personaColors";

export const features = [
  {
    icon: FileText,
    title: "Livros Digitais (ebooks)",
    description: "Material completo sobre Estilo, Imagem, Personas e Sentimentos para consulta permanente.",
    sectionId: "ebooks",
  },
  {
    icon: ClipboardCheck,
    title: "Testes de Estilo",
    description:
      "Teste Express gratuito ou Grande Teste completo para descobrir suas Personas de Estilo mais importantes..",
    sectionId: "testes",
  },
  {
    icon: GraduationCap,
    title: "Cursos Exclusivos",
    description:
      "Aprenda sobre as 12 Personas e os 32 Sentimentos da Imagem. São materiais indispensáveis para quem quer atingir seus objetivos através da imagem pessoal.",
    sectionId: "cursos",
  },
  {
    icon: MessageCircle,
    title: "Aplicativo 12 Personas de Estilo",
    description:
      "Converse com nossa inteligência artificial sobre seu estilo. Aqui você cria imagens com seu rosto e seu corpo usando os looks que representam sua essência.",
    sectionId: "consultor-ia",
  },
];

export const testimonials = [
  {
    name: "Maria S.",
    text: "O teste revelou exatamente o que eu sentia mas não sabia expressar. Transformou meu guarda-roupa!",
    persona: "Romântica",
  },
  {
    name: "Ana Paula",
    text: "Leonardo Hallal é um gênio. Finalmente entendi meu estilo depois de anos perdida.",
    persona: "Cosmopolita",
  },
  {
    name: "Carla M.",
    text: "A consultoria IA é incrível! É como ter um consultor de moda 24 horas por dia.",
    persona: "Dinâmica",
  },
];

export const ebooks = [
  {
    title: "Guia das 12 Personas de Estilo",
    description:
      "Uma jornada pordentro de cada uma das 12 Personas que envolve:seus acessórios, roupas, cores, estampas, decoração e estilo de vida.",
    link: "https://hallal.com.br/",
  },
  {
    title: "Guia dos 32 Sentimentos",
    description:
      "Uma jornada através dos 32 sentimentos da imagem para transmitir as mensagens certas e também para ler pessoas.",
    link: "https://hallal.com.br/",
  },
  {
    title: "Pacote: Guia Personas + Guia Sentimentos",
    description: "Os dois Guias com preço especial.",
    link: "https://hallal.com.br/",
    highlight: true,
  },
];

export const faqs = [
  {
    question: "O que são as 12 Personas de Estilo?",
    answer:
      "As 12 Personas de Estilo são arquétipos desenvolvidos por Leonardo Hallal que representam diferentes formas de expressão através da imagem. Cada persona carrega características, sentimentos e mensagens específicas que transmitimos através da nossa aparência, vestuário e acessórios.",
  },
  {
    question: "Qual a diferença entre o Teste Express e o Grande Teste?",
    answer:
      "O Teste Express possui 12 perguntas e oferece um primeiro direcionamento sobre suas Personas mais fortes, sendo ideal para quem quer uma visão inicial. O Grande Teste conta com 144 perguntas e oferece um mapeamento completo com porcentagens detalhadas de cada Persona, além de um Mapa de Estilo personalizado.",
  },
  {
    question: "O que é o Perfil de Estilo (Consultor IA)?",
    answer:
      "É uma ferramenta de inteligência artificial treinada na metodologia das 12 Personas. Após fazer o teste, você pode conversar com o Consultor IA para tirar dúvidas sobre combinações, cores, tecidos e receber orientações personalizadas baseadas no seu perfil.",
  },
  {
    question: "Os cursos são online? Como funcionam?",
    answer:
      "Sim, todos os cursos são 100% online e você pode acessar no seu próprio ritmo. Incluem videoaulas, textos complementares e exercícios práticos para você aplicar os conceitos no seu dia a dia.",
  },
  {
    question: "Sou consultor de imagem. Vocês têm condições especiais?",
    answer: "SEntre em contato através do ícone de whatsapp do nosso portal para conhecer as opções disponíveis.",
  },
  {
    question: "Posso fazer o teste mais de uma vez?",
    answer:
      "Sim, você pode refazer o teste quando quiser. É interessante refazer após algum tempo, pois suas Personas podem evoluir conforme mudanças na sua vida, objetivos e autoconhecimento.",
  },
];

export const cursos = [
  {
    title: "Curso: 12 Personas de Estilo",
    description:
      "Uma viagem ao fundo da sua essência com explicação detalhada de cada uma das 12 personas. Inclui mais de 2000 com imagens de roupas, acessórios, cores, estampas, decoração, estéticas e estilo de vida. Ideal para indivíduos que querem encontrar sua melhor imagem, uma imagem autêntica, real e interessante. Importantíssimo para a formação de Consultores de Imagem e Estilo. Inclui o grande teste das 12 Personas e o recebimento do Mapa de Estilo personalizado.",
    link: "https://hallal.com.br/",
  },
  {
    title: "Curso: 32 Sentimentos da Imagem",
    description:
      "Aqui você descobrirá quais os 32 sentimentos mais impactantes que sua imagem é capaz de transmitir. Quais sentimentos estão por de trás de cada Persona. Ideal para indivíduos que querem aprender a transmitir as mensagens certas com sua própria imagem para atingir seus objetivos pessoais e profissionais. Ensina a ler pessoas através da imagem, decoração e estilo de vida. Indispensável para consultores de Imagem.",
    link: "https://hallal.com.br/",
  },
  {
    title: "Pacote: Os Dois Cursos",
    description: "Os 2 cursos com preço especial.",
    link: "https://hallal.com.br/",
    highlight: true,
  },
];

export const personaChartData = [
  { name: "Cosmopolita", percentage: 12.5, slug: "cosmopolita" },
  { name: "Sexy", percentage: 10.5, slug: "sexy" },
  { name: "Clássica", percentage: 10.5, slug: "classica" },
  { name: "Dinâmica", percentage: 10.5, slug: "dinamica" },
  { name: "Despretensiosa", percentage: 8.5, slug: "despretensiosa" },
  { name: "Básica", percentage: 8.5, slug: "basica" },
  { name: "Natural", percentage: 8.5, slug: "natural" },
  { name: "Dramática", percentage: 8.0, slug: "dramatica" },
  { name: "Mística", percentage: 6.0, slug: "mistica" },
  { name: "Criativa", percentage: 6.0, slug: "criativa" },
  { name: "Lúdica", percentage: 5.0, slug: "ludica" },
  { name: "Romântica", percentage: 5.5, slug: "romantica" },
].map((item) => ({
  ...item,
  value: item.percentage,
  fill: PERSONA_COLORS[item.slug],
}));

export const personas = [
  "Despretensiosa",
  "Romântica",
  "Cosmopolita",
  "Sexy",
  "Clássica",
  "Básica",
  "Mística",
  "Criativa",
  "Dramática",
  "Lúdica",
  "Natural",
  "Dinâmica",
];

export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
